import { useTranslation } from "react-i18next";

import { DangerZoneWrapper } from "~/components/settings/DangerZoneWrapper";

import { BulkCleanBinsDangerZone } from "./BulkCleanBinsDangerZone";
import { RemoveBinDangerZone } from "./RemoveBinDangerZone";

export function DangerZonesSection() {
  const { t } = useTranslation();

  return (
    <DangerZoneWrapper title={t("danger zone section title")}>
      <RemoveBinDangerZone />
      <BulkCleanBinsDangerZone />
    </DangerZoneWrapper>
  );
}
